import { Type } from '@lendi/lala-react';
import { getTypeFromHostname } from '@lendi/lala-utils';

import { ENVIRONMENT } from '@funnels/constants';

// for temporary usage and demo
// view type might be defined by hostname (e.g. team.lendi.com.au), and the value can be grabed from auth state.
export default function getViewType() {
  let type = Type.Customer;
  const viewFromLocal = window.localStorage.getItem('_lendi_funnels_debug_view') ?? '';

  if (viewFromLocal && ENVIRONMENT === 'development') {
    type = viewFromLocal as Type;
    return type;
  }

  return getTypeFromHostname();
}
